import { render, staticRenderFns } from "./EditarDatos.vue?vue&type=template&id=71939434&scoped=true&"
import script from "./EditarDatos.vue?vue&type=script&lang=js&"
export * from "./EditarDatos.vue?vue&type=script&lang=js&"
import style0 from "./EditarDatos.vue?vue&type=style&index=0&id=71939434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71939434",
  null
  
)

export default component.exports